import { inject, Injectable } from '@angular/core';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';

@Injectable({
  providedIn: 'root',
})
export abstract class ArableService {
  protected readonly env: AgrEnvironment = inject(EnvironmentInjector);

  protected readonly baseUrl: URL = new URL(`${this.env.APIM_BASE_URL}/arable-service/`);
}
